import { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ children }: { children: JSX.Element }) => {
    const location = useLocation();

    const token =
        localStorage.getItem("access") || sessionStorage.getItem("access");

    const user = JSON.parse(
        localStorage.getItem("user") || sessionStorage.getItem("user") || "{}"
    );

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (
        user &&
        user.id &&
        !user.mfa_exempt &&
        !user.mfa_enabled &&
        location.pathname !== "/setup-mfa"
    ) {
        return <Navigate to="/setup-mfa" replace />;
    }

    return children;
};

export default RequireAuth;